import { defineStore } from "pinia";

export const usePortalStore = defineStore("portal", {
  state: () => ({}),
  actions: {},
});
